import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100vh',
    flexDirection: 'column',
    flexBasis: '100%'
  },

  gridBody: {
    flex: 1,
    width: '100%',
    marginBottom: 50,
    '& > div > div': {
      '-webkit-overflow-scrolling': 'touch'
    },
    '& > div > div > div': {
      position: 'relative',
      margin: 'auto'
    }
  },
  gridHeader: {
    flex: 0,
    width: '100%',
    background: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main)
  },
  headerWrapper: {
    margin: 'auto',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '1248px',
      padding: '12px 24px'
    }
  },
  headerTitle: {
    margin: 'auto',
    padding: '12px 24px',
    alignItems: 'center',
    background: theme.palette.primary.dark,
    color: theme.palette.getContrastText(theme.palette.primary.dark)
  },
  headerTitleContent: {
    maxWidth: '1200px',
    margin: 'auto'
  },
  headerTitleTypo: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 45px)'
    }
  },

  logo: {
    paddingBottom: 8
  },
  logoImage: {
    height: 80,
    marginRight: 10,
    [theme.breakpoints.down('xs')]: {
      marginBottom: 8
    }
  },
  buttonRoute: {
    zIndex: 1200,
    display: 'flex',
    marginLeft: 'auto',
    [theme.breakpoints.up('md')]: {
      transform: 'scale(1.5,1.5)',
      transformOrigin: 'right center',
      marginRight: 8
    }
  },
  detail: {
    width: '100%',
    display: 'flex',
    justifyContent: 'left',
    padding: '8px 0',
    '& svg': {
      marginRight: 8
    }
  },
  phone: {
    cursor: 'pointer'
  },

  product: {
    transition: '.3s ease',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: 120,
    padding: '12px 12px 12px 132px',
    borderRadius: 12,
    background: theme.palette.background.paper,
    textTransform: 'none',
    textAlign: 'left',
    cursor: 'pointer',
    boxShadow: '2px 2px 3px rgba(0,0,0, .15)',
    '&:hover, &:active': {
      background: '#fff'
    },

    [theme.breakpoints.up('md')]: {
      '&:hover, &:active': {
        zIndex: 5,
        boxShadow: '6px 6px 10px rgba(0,0,0, .3)',
        transform: 'scale(1.05)',
        '& $rightIcon': {
          opacity: 1,
          transform: 'scale(1)'
        }
      }
    }
  },
  texts: {
    width: '100%',
    marginBottom: 10
  },
  text: {
    ...theme.gofind.lineLimit(2)
  },
  rightIcon: {
    transition: 'all 0.2s cubic-bezier(.17,.67,.58,.73)',
    position: 'absolute',
    right: 6,
    bottom: 6,
    [theme.breakpoints.up('md')]: {
      opacity: 0,
      transform: 'scale(0.5)'
    }
  },
  link: { color: '#fff' },
  img: {
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: '.3s ease',
    position: 'absolute',
    top: 0,
    left: 0,
    width: 120,
    height: 120,
    background: '#fff',
    '& > img': {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  },
  imageMissing: {
    width: 60
  },
  gridFooter: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: 50,
    boxShadow: '0 -2px 3px rgba(33,33,33,.1)',
    background: '#fff'
  },
  logoGofind: {
    width: 80,
    display: 'block',
    margin: 'auto',
    '& img': {
      maxWidth: '100%'
    }
  },
  menuTop: {
    position: 'fixed'
  },
  buttonWrap: {
    position: 'absolute',
    top: -28,
    right: 24
  },
  notFound: {
    opacity: 1,
    animation: '$showBox 1s',
    minHeight: '100vh'
  },
  notFoundProducts: {
    opacity: 1,
    animation: '$showBox 1s',
    height: '100%',
    width: '100%',
    textAlign: 'center',
    padding: '20px'
  },
  imgNotFound: {
    display: 'block',
    maxWidth: 200,
    margin: 'auto',
    maxHeight: '40vw',
    '@media (max-width:374px)': {
      display: 'none'
    }
  },
  titleWrap: {
    width: '100% !important',
    height: 132,
    padding: 12,
    paddingBottom: 24,
    alignContent: 'flex-end'
  },

  '@keyframes showBox': {
    '0%': {
      opacity: 0,
      transform: 'translateY(-50px)'
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0px)'
    }
  }
}))

export default useStyles
